module.exports = __webpack_public_path__ + "static/media/american-express.ff1d6bbb.svg";